import { instance } from "../libs/client";

class NodeService {
  listNodes = async () => {
    return instance.get("nodes/");
  };
}
const nodeService = new NodeService();
export { nodeService };
